import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getBooks } from './books';
import Item from './components/Item';

import './index.scss';

const b = b_.with('main-page-books');

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const Books: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()} data-testid={'main-page-books'}>
      <h2 className={b('title')}>{t('Our books about finance')}</h2>
      <div className={b('wrapper')}>
        {getBooks(t).map((book, index) => (
          <Item key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default translate(Books);
